// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = 'vote/2021project/q1/2021wenxin/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};

// 获取文心课堂下的作文列表
const getArticleList = (page: number) => {
  return http.get(`${urlPrefix}vote-list`, {
    params: {
      page,
    },
  });
};
enum WorkType {
  'teacher' = 1,
  'notes' = 2,
}
interface IHomeData {
  page: number;
  workType: WorkType.notes | WorkType.teacher;
  search?: string;
}
// 获取首页列表
const getHomeList = ({ page, workType, search }: IHomeData) => {
  return http.get(`${urlPrefix}teacher-list`, {
    params: {
      page,
      workType,
      search,
    },
  });
};
// 搜索
const getSearchResult = ({ page, workType, search }: IHomeData) => {
  return http.get(`${urlPrefix}teacher-list`, {
    params: {
      page,
      workType,
      search,
    },
  });
};
// 获取助力人数
const getVoteNumTotal = () => {
  return http.get(`${urlPrefix}user-helper`);
};

// 获取详情页数据
const getDetail = (id: string, workType: string) => {
  return http.get(`${urlPrefix}teacher-detail`, {
    params: {
      id,
      workType,
    },
  });
};

// 获取用户上传列表
const getUserUploadHistory = (page: number) => {
  return http.get(`${urlPrefix}user-list`, {
    params: {
      page,
    },
  });
};
// 删除文章
const delArticle = (id: string | number) => {
  return http.get(`${urlPrefix}user-del`, {
    params: {
      id,
    },
  });
};
const getRule = () => {
  return http.get(`${urlPrefix}rules`);
};

export {
  getBaseInfo,
  getArticleList,
  getHomeList,
  getSearchResult,
  getVoteNumTotal,
  getDetail,
  getUserUploadHistory,
  delArticle,
  getRule,
};
